import React from 'react'
import { Expansible } from 'components/Expansible'
import { AccessTime } from '@mui/icons-material'
import Container from './styles'
import FinancialPendingsTable from './FinancialPendingsTable'
import BuildResumeBoard from './BuildResumeBoard'
import BuildScoreData from '../BuildScoreData'
import { groupPendenciesByInformant } from '../../../../utils/financial_situation_utils'

function BuildFinancialSituation(props) {
  const { financial_situation } = props
  const creditScore = financial_situation?.credit_score_data?.quod_score
  const financialPendencies =
  financial_situation?.financial_pendings_data?.details?.data
  ?.credit_restrictions_data?.financial_pending
  const occurrences = financialPendencies?.occurrences
  const bases = groupPendenciesByInformant(occurrences)

  const renderProcessingFinancialPendings = () => (
    <div style={{ padding: 10, margin: '10px 0', backgroundColor: '#EFEFEF' }}>
      <span style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
        <AccessTime style={{ fontSize: '2rem' }} />
        
        O Background Check ainda está consultando as
        pendências financeiras. Por favor aguarde.
      </span>
    </div>
  )

  const totalValue = financialPendencies?.total_value
  const totalValueUniq  = financialPendencies?.total_value_without_duplicates

  return (
    <div>
      <BuildScoreData score={creditScore} />
  
      {financial_situation?.financial_pendings_data === null && renderProcessingFinancialPendings() }
      { financial_situation?.financial_pendings_data &&  (
        <Container>
          <BuildResumeBoard
            boardData={bases}
            quantity={financialPendencies?.quantity_occurrences || 0}
            totalAmount={totalValueUniq || totalValue}
          />

          {occurrences?.length && (
            <Expansible title="pendências" open={false}>
              <FinancialPendingsTable pendings={occurrences} totalValue={totalValue} totalValueWithoutDuplicates={totalValueUniq} />
            </Expansible>
          )}
        </Container>
      )}
    </div>
  )
}

export default BuildFinancialSituation
